import Flatten from "@flatten-js/core";

import { getControlPoint, getXOffsetFactor, getYOffsetFactor } from "./curve.ts";
import type { CurveConfig, DrawingCurveDescriptor, GeometricDrawing } from "./types.ts";

const { point } = Flatten;

export const getDrawingCurveDescriptor = ({
  drawing,
  options: { straight, fromPadding, minControlDistance = 0 },
}: {
  drawing: GeometricDrawing;
  options: CurveConfig;
}): DrawingCurveDescriptor => {
  const startOffset = point(drawing.from.point.x, drawing.from.point.y);

  const startCurve = point(
    drawing.from.point.x + (fromPadding + straight) * getXOffsetFactor(drawing.from.edge),
    drawing.from.point.y + (fromPadding + straight) * getYOffsetFactor(drawing.from.edge),
  );

  const controlPointA = getControlPoint(drawing.from.edge, startCurve, minControlDistance, minControlDistance);
  const endOffset = point(drawing.to.x, drawing.to.y);

  return {
    startOffset,
    startCurve,
    controlPointA,
    endOffset,
  };
};
